var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgResultadosHome(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 46.793,
    height: 40.485,
    viewBox: "0 0 46.793 40.485",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Resultados_Home",
    "data-name": "Resultados Home",
    transform: "translate(-598.85 -1440.824)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_165679",
    "data-name": "Grupo 165679",
    transform: "translate(8052.316 6845.99)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_164309",
    "data-name": "Grupo 164309",
    transform: "translate(-7453.063 -5403.821)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_95094",
    "data-name": "Trazado 95094",
    d: "M-9209.137-2620.431h45.391",
    transform: "translate(9209.137 2624.906)",
    fill: "none",
    stroke: "#05294f",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_95095",
    "data-name": "Trazado 95095",
    d: "M-9209.137-2620.431h45.391",
    transform: "translate(9209.137 2631.457)",
    fill: "none",
    stroke: "#05294f",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_95096",
    "data-name": "Trazado 95096",
    d: "M-9209.137-2620.431h45.391",
    transform: "translate(9209.137 2637.413)",
    fill: "none",
    stroke: "#05294f",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_95097",
    "data-name": "Trazado 95097",
    d: "M-9209.137-2620.431h45.391",
    transform: "translate(9209.137 2643.368)",
    fill: "none",
    stroke: "#05294f",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_95098",
    "data-name": "Trazado 95098",
    d: "M-9209.137-2620.431h45.391",
    transform: "translate(9209.137 2649.323)",
    fill: "none",
    stroke: "#05294f",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_95099",
    "data-name": "Trazado 95099",
    d: "M-9209.137-2620.431h45.391",
    transform: "translate(9209.137 2655.278)",
    fill: "none",
    stroke: "#05294f",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_95101",
    "data-name": "Trazado 95101",
    d: "M0,0H38.975",
    transform: "translate(6.021 0) rotate(90)",
    fill: "none",
    stroke: "#05294f",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_95102",
    "data-name": "Trazado 95102",
    d: "M0,0H38.975",
    transform: "translate(11.976 0) rotate(90)",
    fill: "none",
    stroke: "#05294f",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_95103",
    "data-name": "Trazado 95103",
    d: "M0,0H38.975",
    transform: "translate(17.931 0) rotate(90)",
    fill: "none",
    stroke: "#05294f",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_95104",
    "data-name": "Trazado 95104",
    d: "M0,0H38.975",
    transform: "translate(23.887 0) rotate(90)",
    fill: "none",
    stroke: "#05294f",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_95105",
    "data-name": "Trazado 95105",
    d: "M0,0H38.975",
    transform: "translate(29.842 0) rotate(90)",
    fill: "none",
    stroke: "#05294f",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_95106",
    "data-name": "Trazado 95106",
    d: "M0,0H38.975",
    transform: "translate(35.797 0) rotate(90)",
    fill: "none",
    stroke: "#05294f",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_95107",
    "data-name": "Trazado 95107",
    d: "M0,0H38.975",
    transform: "translate(41.752 0) rotate(90)",
    fill: "none",
    stroke: "#05294f",
    strokeWidth: 0.3
  })), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_95092",
    "data-name": "Trazado 95092",
    d: "M78.946,35.841h-.782c-.181,0-.328-.224-.328-.5s.147-.5.328-.5h.782c.181,0,.328.224.328.5S79.127,35.841,78.946,35.841Z",
    transform: "translate(-7489.835 -5417.089)",
    fill: "#05294f",
    stroke: "#05294f",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_164308",
    "data-name": "Grupo 164308",
    transform: "translate(-7452.466 -5404.166)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_95090",
    "data-name": "Trazado 95090",
    d: "M45.089,20.059H31.032l-1.8,6.43a.28.28,0,0,1-.547-.045l-.958-8.922L25.072,36.508a.272.272,0,0,1-.286.24.28.28,0,0,1-.271-.257L21.948,5.055l-4.019,22.3a.28.28,0,0,1-.551,0L15.543,17.27,14.307,19.9a.281.281,0,0,1-.254.161H7.492a.28.28,0,1,1,0-.56h6.384l1.532-3.259a.28.28,0,0,1,.529.069l1.715,9.429,4.125-22.89a.276.276,0,0,1,.289-.229.279.279,0,0,1,.265.257l2.537,31.053L27.489,15.2a.276.276,0,0,1,.281-.241.28.28,0,0,1,.274.25l1.044,9.723L30.551,19.7a.279.279,0,0,1,.27-.2H45.075Z",
    transform: "translate(-3.695 -0.659)",
    fill: "none",
    stroke: "#05294f",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_149145",
    "data-name": "Rect\\xE1ngulo 149145",
    width: 44.793,
    height: 38.485,
    rx: 4.982,
    transform: "translate(0)",
    fill: "none",
    stroke: "#05294f",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgResultadosHome);
export default __webpack_public_path__ + "static/media/Resultados Home.2c08c79bda8c30fcf732016f3e65c5b2.svg";
export { ForwardRef as ReactComponent };